import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrailerContinuityReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxF: ExcludableTextbox;
    excludabletextboxT: ExcludableTextbox;
    sourceTrailerContinuity: DataSource;
    switchIncludeExeptionOnly: Switch;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxDriverType: Textbox;
    textboxTrailerStatus: Textbox;
}
